import React from 'react';
import { ReviewPageLink } from './Styled';
import { AnchorProps } from '../../../types';

const Anchor = ({ children, href, onClick }: AnchorProps) => (
  <ReviewPageLink href={href} title={children} onClick={onClick} />
);

Anchor.defaultProps = {};

export default Anchor;
export { Anchor };
